const MAX_CONNECTION_TIMEOUT_WAIT_DURATION = 2000;
const RELIABLE_URL = 'https://www.dazn.com'; // NB: google.com does not allows CORS requests

/**
 * Initially tests `navigator.onLine`, followed by a HEAD request to
 * a reliable URL, and makes an assumption that the internet connection
 * is functioning or not.
 *
 * If the request takes longer than 2 seconds, the internet connection is
 * assumed to have been lost.
 */

const getIsConnectionOk = async (
    isNavigatorOnline: boolean = navigator.onLine,
    injectedFetch: (...args) => Promise<any> = fetch,
    timeout: number = MAX_CONNECTION_TIMEOUT_WAIT_DURATION
): Promise<boolean> => {
    if (!isNavigatorOnline) return false;

    return await new Promise<boolean>((resolve) => {
        const timeoutId = setTimeout(() => resolve(false), timeout);

        injectedFetch(RELIABLE_URL, {method: 'HEAD'})
            .then(response => {
                clearTimeout(timeoutId);
                resolve(response.ok);
            })
            .catch(() => resolve(false));
    });
};

export default getIsConnectionOk;
